"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _StatusMessageDto = _interopRequireDefault(require("../model/StatusMessageDto"));

var _UploadSummaryDto = _interopRequireDefault(require("../model/UploadSummaryDto"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* TreatmentPlan service.
* @module 1/TreatmentPlanApi
* @version 5.0.10
*/
var TreatmentPlanApi = /*#__PURE__*/function () {
  /**
  * Constructs a new TreatmentPlanApi. 
  * @alias module:1/TreatmentPlanApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function TreatmentPlanApi(apiClient) {
    _classCallCheck(this, TreatmentPlanApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Gets the list of treatment plans ids. (Requires: Roles -> RH.TP.ReadList, RH.TP.L, RH.TP.Admin).
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<String>} and HTTP response
   */


  _createClass(TreatmentPlanApi, [{
    key: "treatmentplansGetWithHttpInfo",
    value: function treatmentplansGetWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ['String'];
      return this.apiClient.callApi('/treatmentplans', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Gets the list of treatment plans ids. (Requires: Roles -> RH.TP.ReadList, RH.TP.L, RH.TP.Admin).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<String>}
     */

  }, {
    key: "treatmentplansGet",
    value: function treatmentplansGet() {
      return this.treatmentplansGetWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Uploads a treatment plan. (Requires: Roles -> RH.TP.Create, RH.TP.C, RH.TP.Admin).
     * @param {File} file 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UploadSummaryDto} and HTTP response
     */

  }, {
    key: "treatmentplansPostWithHttpInfo",
    value: function treatmentplansPostWithHttpInfo(file) {
      var postBody = null; // verify the required parameter 'file' is set

      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling treatmentplansPost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {
        'file': file
      };
      var authNames = ['Bearer'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = _UploadSummaryDto["default"];
      return this.apiClient.callApi('/treatmentplans', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Uploads a treatment plan. (Requires: Roles -> RH.TP.Create, RH.TP.C, RH.TP.Admin).
     * @param {File} file 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UploadSummaryDto}
     */

  }, {
    key: "treatmentplansPost",
    value: function treatmentplansPost(file) {
      return this.treatmentplansPostWithHttpInfo(file).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Deletes the treatment plan. (Requires: Roles -> RH.TP.Delete, RH.TP.D, RH.TP.Admin).
     * @param {String} treatmentPlanId The treatment plan identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "treatmentplansTreatmentPlanIdDeleteWithHttpInfo",
    value: function treatmentplansTreatmentPlanIdDeleteWithHttpInfo(treatmentPlanId) {
      var postBody = null; // verify the required parameter 'treatmentPlanId' is set

      if (treatmentPlanId === undefined || treatmentPlanId === null) {
        throw new Error("Missing the required parameter 'treatmentPlanId' when calling treatmentplansTreatmentPlanIdDelete");
      }

      var pathParams = {
        'treatmentPlanId': treatmentPlanId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = null;
      return this.apiClient.callApi('/treatmentplans/{treatmentPlanId}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Deletes the treatment plan. (Requires: Roles -> RH.TP.Delete, RH.TP.D, RH.TP.Admin).
     * @param {String} treatmentPlanId The treatment plan identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "treatmentplansTreatmentPlanIdDelete",
    value: function treatmentplansTreatmentPlanIdDelete(treatmentPlanId) {
      return this.treatmentplansTreatmentPlanIdDeleteWithHttpInfo(treatmentPlanId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Downloads the treatment plan archive. (Requires: Roles -> RH.TP.Read, RH.TP.R, RH.TP.L, RH.TP.Admin).
     * @param {String} treatmentPlanId The treatment plan identifier.
     * @param {Object} opts Optional parameters
     * @param {String} opts.treatmentPlanFilename The treatment plan filename.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link File} and HTTP response
     */

  }, {
    key: "treatmentplansTreatmentPlanIdGetWithHttpInfo",
    value: function treatmentplansTreatmentPlanIdGetWithHttpInfo(treatmentPlanId, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'treatmentPlanId' is set

      if (treatmentPlanId === undefined || treatmentPlanId === null) {
        throw new Error("Missing the required parameter 'treatmentPlanId' when calling treatmentplansTreatmentPlanIdGet");
      }

      var pathParams = {
        'treatmentPlanId': treatmentPlanId
      };
      var queryParams = {
        'treatmentPlanFilename': opts['treatmentPlanFilename']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/octet-stream'];
      var returnType = File;
      return this.apiClient.callApi('/treatmentplans/{treatmentPlanId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Downloads the treatment plan archive. (Requires: Roles -> RH.TP.Read, RH.TP.R, RH.TP.L, RH.TP.Admin).
     * @param {String} treatmentPlanId The treatment plan identifier.
     * @param {Object} opts Optional parameters
     * @param {String} opts.treatmentPlanFilename The treatment plan filename.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */

  }, {
    key: "treatmentplansTreatmentPlanIdGet",
    value: function treatmentplansTreatmentPlanIdGet(treatmentPlanId, opts) {
      return this.treatmentplansTreatmentPlanIdGetWithHttpInfo(treatmentPlanId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return TreatmentPlanApi;
}();

exports["default"] = TreatmentPlanApi;